import React from 'react';
import styled from 'styled-components/macro';

import { OpenConvalidaResponse, Group, Task, Definition } from 'models/response';

import utils from 'utils';

import { Title } from '../index';
import MultiTabs from 'components/Tabs/MultiTabs';
import NextTask from '../nextTask';
import Definitions from './definitions';

export const WrapperTabs = styled.div`
  display: flex;
  flex-direction: row;
  > div:first-child {
    width: 100%;
  }
`;

interface Props {
  response: OpenConvalidaResponse;
  setSelectedDefinition: (definition: Definition) => void;
  setSelectedTask: (isActive?: boolean, task?: Task) => void;
  setSelectedGroups: (groups: Group[]) => void;
  setSelectedTab: (index: number) => void;
}

const Reference = ({ response, setSelectedDefinition, setSelectedTask, setSelectedGroups, setSelectedTab }: Props) => {
  const t = utils.intl.useTranslator();

  const tabs = [
    {
      name: t('next_task'),
      content: (
        <NextTask
          title="next-tasks-title"
          response={response}
          setSelectedTask={setSelectedTask}
          setSelectedGroups={setSelectedGroups}
        />
      ),
      id: 1,
    },
    {
      name: t('definitions'),
      content: (
        <Definitions
          response={response}
          setSelectedDefinition={setSelectedDefinition}
          setSelectedTask={setSelectedTask}
          setSelectedGroups={setSelectedGroups}
        />
      ),
      id: 2,
    },
  ];

  return (
    <>
      <Title>{t('destinatario')}</Title>
      <WrapperTabs>
        <MultiTabs tabs={tabs} setActiveTabExternal={setSelectedTab} />
      </WrapperTabs>
    </>
  );
};

export default Reference;
